/**
 * Filtrage des etapes conditionnelles du wizard d'inscription.
 *
 * Extrait du composant pour etre testable sans monter toute la page :
 * c'est la seule source de verite du nombre d'etapes, utilisee a la fois par
 * le rendu, la navigation, la barre de progression et le bouton final.
 *
 * Drapeaux portes par une etape :
 *  - professionalOnly : reservee aux profils professionnels
 *  - paidOnly         : liee au choix d'un abonnement payant, retiree pendant
 *                       la beta ou l'inscription est gratuite
 */
export const getVisibleWizardSteps = (steps, { isProfessional = false, hidePaidSteps = false } = {}) => {
    if (!Array.isArray(steps)) return [];

    return steps.filter((step) => {
        if (step.professionalOnly && !isProfessional) return false;
        if (step.paidOnly && hidePaidSteps) return false;
        return true;
    });
};

export default getVisibleWizardSteps;
